export default __webpack_public_path__ + "static/media/memsql.6bfaf0ce.svg";